import React, { FC, ReactNode } from 'react';

import { DateTime } from 'luxon';
import { IntlShape } from 'react-intl';

import { commonMessages } from '~/utility/commonMessages';

type Props = {
    gameData: any;
    intl: IntlShape;
    value?: ReactNode;
};

const GameCell: FC<Props> = ({ gameData, intl, value }) => {
    let cellMarkup;

    if (gameData.opponentTeamAbbrev && gameData.gameDate) {
        let gameLabel = DateTime.fromISO(gameData.gameDate).toFormat('yyyy/LL/dd');

        if (gameData.homeRoad === 'H') {
            gameLabel = `${gameLabel} ${intl.formatMessage(commonMessages.labels.vs)} `;
        } else if (gameData.homeRoad === 'R') {
            gameLabel = `${gameLabel} @ `;
        } else {
            gameLabel = `${gameLabel} ${intl.formatMessage(commonMessages.labels.vs)} `;
        }

        gameLabel = `${gameLabel}${gameData.opponentTeamAbbrev}`;

        const currentLanguage = window.__SITE_LANGUAGE_CODE__;
        const languagePartInUrl = currentLanguage === 'en' ? '/' : `/${currentLanguage}/`;
        const gamecenterLink = `https://${window.location.host}${languagePartInUrl}gamecenter/${gameData.gameId}`;

        cellMarkup = (
            <div>
                <a href={gamecenterLink}>{gameLabel}</a>
            </div>
        );
    } else if (gameData.gameDate) {
        const gameLabel = DateTime.fromISO(gameData.gameDate).toFormat('yyyy/LL/dd');

        const currentLanguage = window.__SITE_LANGUAGE_CODE__;
        const languagePartInUrl = currentLanguage === 'en' ? '/' : `/${currentLanguage}/`;
        const gamecenterLink = `https://${window.location.host}${languagePartInUrl}gamecenter/${gameData.gameId}`;

        cellMarkup = (
            <div>
                <a href={gamecenterLink}>{gameLabel}</a>
            </div>
        );
    } else {
        cellMarkup = <div>{value}</div>;
    }

    return cellMarkup;
};

export default React.memo(GameCell);
